import "../../_namespaces.js";
window.AssessmentViewer ??= {};
window.AssessmentViewer.Views ??= {};

AssessmentViewer.Views.ResponseListSelectMultipleChoice = class ResponseListSelectMultipleChoice extends Backbone.View {
  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
  }

  render() {
    this.$el.html(
      this.collection.map((response) => {
        response = new AssessmentViewer.Views.ResponseSelectMultipleChoice({ model: response });
        return jQuery("<li>").append(response.render().el);
      }),
    );

    return this;
  }
};
AssessmentViewer.Views.ResponseListSelectMultipleChoice.prototype.tagName = "ul";
AssessmentViewer.Views.ResponseListSelectMultipleChoice.prototype.className = "response-list";
